import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { openPopup } from "../../../store/popupSlice";
import QueryPopup from "../../Query_popup/QueryPopup";
import { Helmet } from "react-helmet-async";
import Breadcrumb from "../../../component/Breadcrumb";

const  breadcrumbData = {
    newClass: "",
    list: [
      {
        page: "Home",
        slug: "/"
      },
      {
        page: "uber Clone App",
        slug: ""
      },
    ]
  }

export default function UberBanner() {
  const dispatch = useDispatch();
  return (
    <>
      <Helmet>
        <link rel="preload" href="/assets/home/uber-banner.webp" as="image" type="image/webp"/>
      </Helmet>
      <section className="lft-banner">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <div class="banner-content">
                <Breadcrumb breadcrumbData={breadcrumbData}/>
                <Link className="new-mobility">mobility Infotech</Link>

                <h1 className="heading"> Empower Your Venture with a Scalable <span className="gradiant-color">Uber Clone App</span> </h1>
                <p>Launch your ride-hailing business in record time with a high-performance Uber clone app. At Mobility Infotech, we deliver white-label solutions that aren't just duplicates but engineered ecosystems designed to scale. Our Uber clone app development approach focuses on 99.9% uptime and AI-driven efficiency to ensure your platform dominates the local market from day one.</p>

                <small>21 Days Free Trial | No Credit Card Required</small>

                <div className="lyft-banner-btn">
                  <Link
                    style={{marginRight:"15px"}}
                    className="default-btn animated-btn"
                    onClick={() => dispatch(openPopup())}
                  >
                    schedule a metting
                  </Link>
                  <Link className="default-btn" to={"/features/taxi-software"}>
                    features
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="banner-image">
                <img className="img-responsive" src="/assets/home/uber-banner.webp" alt="logo"/>
              </div> 
            </div>
          </div>
        </div>

        <QueryPopup />
      </section>
    </>
  )
}
